module.exports = __webpack_public_path__ + "static/media/d2.d64e592f.png";